import React, { useRef } from "react";
import { Avatar, Button, Card, Space, Typography } from "antd";
import { CheckOutlined, CloseOutlined, GlobalOutlined } from "@ant-design/icons";
import Cookies from "universal-cookie";

const { Paragraph, Text, Title } = Typography;

function appInitial(name) {
    if (!name) return "?";
    const trimmed = String(name).trim();
    return trimmed ? trimmed[0].toUpperCase() : "?";
}

function shortHost(url) {
    if (!url) return "";
    try {
        return new URL(url).host;
    } catch (e) {
        return url;
    }
}

export default function Authorize({ service }) {
    const frmRef = useRef();

    const grantAccess = () => {
        frmRef.current.submit();
    };

    const denyAccess = () => {
        const cookies = new Cookies();
        cookies.remove("SSO_requestService", { path: "/" });
        window.location.reload();
    };

    return (
        <Card>
            <Space direction="vertical" size={20} style={{ width: "100%" }}>
                <Space size={16} align="start" style={{ width: "100%" }}>
                    <Avatar size={56} shape="square" style={{ flexShrink: 0 }}>
                        {appInitial(service?.Name)}
                    </Avatar>
                    <div style={{ minWidth: 0, flex: 1 }}>
                        <Title level={4} style={{ margin: 0 }}>
                            {service?.Name || "Application"}
                        </Title>
                        <Text type="secondary" style={{ wordBreak: "break-all" }}>
                            <GlobalOutlined style={{ marginRight: 6 }} />
                            {shortHost(service?.URL) || service?.URL}
                        </Text>
                    </div>
                </Space>

                <Paragraph style={{ margin: 0 }}>
                    This application is requesting access to your ChulaSSO identity.
                    If you trust it, click <Text strong>Grant</Text> to continue. Otherwise
                    click <Text strong>Deny</Text>.
                </Paragraph>

                <form
                    action="/api/tickets/grantTicket"
                    method="post"
                    ref={frmRef}
                    style={{ display: "none" }}
                />

                <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                    <Button icon={<CloseOutlined />} onClick={denyAccess}>
                        Deny
                    </Button>
                    <Button
                        type="primary"
                        icon={<CheckOutlined />}
                        onClick={grantAccess}
                    >
                        Grant
                    </Button>
                </Space>
            </Space>
        </Card>
    );
}
